import { Typography } from '@telavita-core/react-design-kit'
import React from 'react'

import { EmptyMessage } from './styles'

interface IPatientEmptyMessageProps {
  activeTab: number
  showEmptyMessage: boolean
}

export const PatientsEmptyMessage = ({
  activeTab,
  showEmptyMessage,
}: IPatientEmptyMessageProps): JSX.Element => {
  return (
    <>
      {showEmptyMessage ? (
        <EmptyMessage>
          <Typography
            variant='content3'
            center
          >
            {`Nenhum paciente ${activeTab === 0 ? 'faltou' : 'cancelou'} no período acima.`}
          </Typography>
        </EmptyMessage>
      ): null}
    </>
  )
}